import { Component, OnInit } from '@angular/core';
import { ProductService } from './../Services/product.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.css']
})
export class AddProductComponent implements OnInit {
  products: any;
  dProducts: any;
  editEnable: boolean;
  Eproduct: any;
  new_Product: boolean;
  newProductId:string;
  newProductTitle: string;
  newProductDesc: string;
  newProductType: string;
  newProductPrice: string;
  newPkgName: string;
  editableTitle: string;
  editableDescription: string;
  editableType: string;
  editablePrice: string;
  editablePkgName: string;
  delete=false;

  constructor( private product: ProductService, private router: Router) { }

  ngOnInit() {
    this.getAllProducts();
    
  }
  ngOnchange() {
    this.getAllProducts();
  }



    editProduct(product: string) {
      this.editEnable = true;
      console.log('product',product);
      this.Eproduct = product;
      console.log('Eproduct', this.Eproduct);

    }
    saveEditing(id,product) {
      console.log(id);
      const form = new FormData();
     
      form.append('productId', this.Eproduct.productId);
      form.append('title', this.Eproduct.title);
      form.append('description', this.Eproduct.description);
      form.append('type', this.Eproduct.type);
      form.append('price', this.Eproduct.price);
      form.append('packageName', this.Eproduct.packageName);
      this.product.editProduct(id, form).subscribe(
        next => {
          console.log('next', next);
           this.editEnable = false;
           this.Eproduct = '';
           this.getAllProducts();
    }, error => {
      console.log(error);
    });
    }

    addProduct() {
      const form = new FormData();
      form.append('productId', this.newProductId);
      form.append('title', this.newProductTitle);
      form.append('description', this.newProductDesc);
      form.append('type', this.newProductType);
      form.append('price', this.newProductPrice);
      form.append('packageName', this.newPkgName);
      this.product.addProduct(form).subscribe(
        next => {
        console.log(next);
        this.getAllProducts();
        this.new_Product = !this.new_Product;
        this.newProductTitle = '';
        this.newProductDesc = '';
        this.newProductType = '';
        this.newProductPrice = '';
      }, error => {console.log(error); });
    }


  /**
   * get all
   *@description get all cats from backend 
   */

  getAllProducts() {
    this.product.getProducts().subscribe(
      next => {
      this.products = next;
      console.log(this.products);
    }, error => {console.log(error); });
  }
  getpkgProducts(pkgId) {
    this.product.getpkgProducts(pkgId).subscribe(
      next => {

      }
    );
  }
  deleteProduct(id,index) {
    this.delete = true;
    this.product.deleteProduct(id).subscribe(
      next => {
        this.products.splice(index, 1);
      }
    );
  }


}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/add-product/add-product.component.ts